import { useAuthUser } from "../../auth/hooks/useAuthUser";

export const useStripeConnectAccount = () => {
  const { user } = useAuthUser();
  return {
    account: user?.stripe_account || null,
    setupComplete: user?.stripe_account?.setup_complete || false,
  }
}